// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleText_title__cVLqv","flush":"TitleText_flush__xbRMw","sectionTitle":"TitleText_sectionTitle__pVsPt","srOnly":"TitleText_srOnly__VGUEP"};